export enum DefaultNames {
  Class = "Untitled Class",
}
